import { render, staticRenderFns } from "./WarrantsAnnouncement.vue?vue&type=template&id=313773ac&scoped=true&"
import script from "./WarrantsAnnouncement.js?vue&type=script&lang=js&"
export * from "./WarrantsAnnouncement.js?vue&type=script&lang=js&"
import style0 from "./WarrantsAnnouncement.vue?vue&type=style&index=0&id=313773ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313773ac",
  null
  
)

export default component.exports